import React from 'react';
import {MechanicalSelectionScoreJson} from "pages/mechanical/ImpellerAssemblyService";


export function AssemblyScoreBar({mechanicalSelectionScore, asColumn = true}: { mechanicalSelectionScore: MechanicalSelectionScoreJson, asColumn?: boolean }) {
    let pinBladesheetTensionLabel: string;

    if (mechanicalSelectionScore.pinBladesheetTensionValue !== null) {
        if (mechanicalSelectionScore.pinBladesheetTensionLimit !== null) {
            const ratio = (mechanicalSelectionScore.pinBladesheetTensionValue / mechanicalSelectionScore.pinBladesheetTensionLimit).toFixed(2);
            pinBladesheetTensionLabel = `${mechanicalSelectionScore.pinBladesheetTensionValue.toFixed(2)} MPa / ${mechanicalSelectionScore.pinBladesheetTensionLimit.toFixed(2)} MPa (${ratio})`;
        } else{
            pinBladesheetTensionLabel = `${mechanicalSelectionScore.pinBladesheetTensionValue.toFixed(2)} MPa / Limit N/A`;
        }
    } else {
        pinBladesheetTensionLabel = "N/A";
    }

    return <div className={"d-flex justify-content-center flex-wrap" + (asColumn ? " flex-column" : "")}>
        <div className={"badge " + (mechanicalSelectionScore.kryt1MoMsPassed ? "badge-light-success" : "badge-light-danger")}>
            <i className={mechanicalSelectionScore.kryt1MoMsPassed ? "fas fa-check me-2" : "fas fa-times me-2"}></i>
            Kryt. 1 MoMs ({mechanicalSelectionScore.kryt1MoMsValue.toFixed(2)})
        </div>
        <div className={"badge " + (mechanicalSelectionScore.kryt2MbMsPassed ? "badge-light-success" : "badge-light-danger")}>
            <i className={mechanicalSelectionScore.kryt2MbMsPassed ? "fas fa-check me-2" : "fas fa-times me-2"}></i>
            Kryt. 2 MbMs ({mechanicalSelectionScore.kryt2MbMsValue.toFixed(2)})
        </div>
        <div className={"badge " + (mechanicalSelectionScore.kryt3NrNdPassed ? "badge-light-success" : "badge-light-danger")} style={{opacity: mechanicalSelectionScore.kryt3NrNdValue >= 0 ? 1 : 0.5}}>
            <i className={mechanicalSelectionScore.kryt3NrNdPassed ? "fas fa-check me-2" : "fas fa-times me-2"}></i>
            Kryt. 3 NrNd ({mechanicalSelectionScore.kryt3NrNdValue >= 0 ? mechanicalSelectionScore.kryt3NrNdValue.toFixed(2) : "bez sprzęgła"})
        </div>
        <div className={"badge " + (mechanicalSelectionScore.kryt4NrNzPassed ? "badge-light-success" : "badge-light-danger")} style={{opacity: mechanicalSelectionScore.kryt4NrNzValue >= 0 ? 1 : 0.5}}>
            <i className={mechanicalSelectionScore.kryt4NrNzPassed ? "fas fa-check me-2" : "fas fa-times me-2"}></i>
            Kryt. 4 NrNz ({mechanicalSelectionScore.kryt4NrNzValue >= 0 ? mechanicalSelectionScore.kryt4NrNzValue.toFixed(2) : "bez sprzęgła"})
        </div>
        <div className={"badge " + (mechanicalSelectionScore.resonanceRfPassed ? "badge-light-success" : "badge-light-danger")}>
            <i className={mechanicalSelectionScore.resonanceRfPassed ? "fas fa-check me-2" : "fas fa-times me-2"}></i>
            Rezonans RF
        </div>
        {/*Rfx2 is intenrtionally not here since Oct 2025 */}
        <div className={"badge " + (mechanicalSelectionScore.resonanceBpfPassed ? "badge-light-success" : "badge-light-danger")}>
            <i className={mechanicalSelectionScore.resonanceBpfPassed ? "fas fa-check me-2" : "fas fa-times me-2"}></i>
            Rezonans BPF
        </div>
        <div className={"badge " + (mechanicalSelectionScore.vonMisesPinLoadPassed ? "badge-light-success" : "badge-light-danger")}>
            <i className={mechanicalSelectionScore.vonMisesPinLoadPassed ? "fas fa-check me-2" : "fas fa-times me-2"}></i>
            Czop {mechanicalSelectionScore.vonMisesPinLoadValue.toFixed(2)} / {mechanicalSelectionScore.vonMisesPinLoadLimit.toFixed(2)} ({(mechanicalSelectionScore.vonMisesPinLoadValue / mechanicalSelectionScore.vonMisesPinLoadLimit).toFixed(2)})
        </div>
        <div className={"badge " + ((mechanicalSelectionScore.pinBladesheetTensionPassed) ? "badge-light-success" : "badge-light-danger")}>
            <i className={(mechanicalSelectionScore.pinBladesheetTensionPassed) ? "fas fa-check me-2" : "fas fa-times me-2"}></i>
            Czop-płat ({pinBladesheetTensionLabel}) {mechanicalSelectionScore.enforcementStrategySymbol}
        </div>
    </div>;
}

AssemblyScoreBar.propTypes = {}

AssemblyScoreBar.defaultProps = {}
